module.exports = __webpack_public_path__ + "img/monthly-bonus.bb6a97bc.png";